import { useState } from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import type { UUID, Addendum } from "@/core/types";

import { AddendumActions } from "./AddendumActions";
import { AddendumCosignatureReview } from "./(cosignature)/AddendumCosignatureReview";
import { AddendumDisplay } from "./AddendumDisplay";
import { AddendumRejectionBanner } from "./(rejection)/AddendumRejectionBanner";
import { EditAddendum } from "./(form)/EditAddendum";

type NoteAddendumProps = {
  addendum: Addendum;
  credentials: string | undefined;
  isAuthor: boolean;
  noteId: UUID;
  patientId: UUID;
  signature: string | undefined;
  textTestId?: string;
};

export function NoteAddendum({
  addendum,
  credentials,
  isAuthor,
  noteId,
  patientId,
  signature,
  textTestId,
}: NoteAddendumProps) {
  const [isEditMode, setIsEditMode] = useState(false);

  const isRejected = addendum.addendum_state === "rejected";

  return (
    <DashboardCard2
      Actions={
        <AddendumActions
          addendum={addendum}
          isAuthor={isAuthor}
          isEditMode={isEditMode}
          isRejected={isRejected}
          onEditPress={() => setIsEditMode(true)}
        />
      }
      classNameChildren="tw:flex tw:flex-col tw:gap-6"
      id={`addendum-${addendum.addendum_id}`}
      title="Addendum"
    >
      {isEditMode ? (
        <EditAddendum
          addendumId={addendum.addendum_id}
          credentials={credentials}
          defaultValue={addendum.addendum}
          noteId={noteId}
          onCancel={() => setIsEditMode(false)}
          onSuccess={() => setIsEditMode(false)}
          patientId={patientId}
          signature={signature}
        >
          <AddendumRejectionBanner addendumId={addendum.addendum_id} />
        </EditAddendum>
      ) : (
        <>
          <AddendumDisplay addendum={addendum} textTestId={textTestId} />
          {isRejected ? <AddendumRejectionBanner addendumId={addendum.addendum_id} /> : null}
        </>
      )}

      {!isEditMode && <AddendumCosignatureReview addendum={addendum} patientId={patientId} />}
    </DashboardCard2>
  );
}
